<template>
    <div class="willCheckCoupon">
        <div class="left-box" :class="{flex1:navIndex==1}">
            <div class="nav-box">
                <div class="nav-li" :class="{selected:navIndex==0}" @click="navIndex=0">按卡号查询核销券</div>
                <div class="nav-li" :class="{selected:navIndex==1}" @click="navIndex=1">扫券码直接核销</div>
            </div>
            <div class="tab-pane" v-show="navIndex==0">
                <div class="tr-li card-tr">
                    <div class="lable-txt">卡号：</div>
                    <div class="from-input">
                        <div class="card-no"><input-pattern ref="input" keyBoard placeholder="请输入卡号或读卡" v-model="cardNo" @keyup.enter="selectReadCard()" /><i class="iconfont icon-sousuo" @click="selectReadCard()"></i></div>  
                        <div class="read-card" @click="readCard()">读卡</div>    
                    </div>
                </div>
                <div class="info-box">
                    <div class="title">客户资料信息</div>
                    <div class="tr-li">
                        <div class="lable-txt">会员等级：</div>
                        <div class="from-input"><input type="text" :value="memberInfo?.Bestech_Card_KindName"  readonly/></div>
                    </div>
                    <div class="tr-li">
                        <div class="lable-txt">客户姓名：</div>
                        <div class="from-input"><input type="text"  :value="memberInfo?.MemberName"  readonly/></div>
                    </div>
                    <div class="tr-li">
                        <div class="lable-txt">手机号：</div>
                        <div class="from-input"><input type="text" :value="memberInfo?.Mobile" maxlength="10" readonly/></div>
                    </div>
                    <div class="tr-li">
                        <div class="lable-txt">生日：</div>
                        <div class="from-input"><input type="text" :value="memberInfo?.Birthday" readonly/></div>
                    </div>
                    <div class="tr-li">
                        <div class="lable-txt">性别：</div>
                        <div class="from-input"><input type="text" :value="{0:'男',1:'女'}[memberInfo?.Gender]" readonly/></div>
                    </div>
                    <div class="title">卡资产信息</div>
                    <div class="tr-li">
                        <div class="lable-txt">余额：</div>
                        <div class="from-input"><input class="text-right" type="text" :value="memberInfo?.Card_Money" readonly/>
                            <p class="describe" :style="memberInfo?'':'visibility: hidden'">其中赠送金额{{memberInfo?.Gift_Money}}元</p>
                        </div>
                    </div>
                    <div class="tr-li">
                        <div class="lable-txt">积分：</div>
                        <div class="from-input"><input class="text-right" type="text" :value="memberInfo?.Card_PilePoint"  readonly/>
                            <p class="describe"></p>
                        </div>
                    </div>
                    <div class="tr-li">
                        <div class="lable-txt">券：</div>
                        <div class="from-input ticket" @click="ticketClick()"><input class="text-right" :value="(memberInfo?.Coupons?.length||'0')+'张'" type="text" readonly/><i class="iconfont">></i>
                            <p class="describe"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane" v-show="navIndex==1">
                <div class="scan-coupons-box">
                    请输入或扫码：
                    <div class="from-input">
                        <i v-if="$webBrowser?.isMobile?.Android" class="iconfont icon-a-saoma13x" @click="scanCode"></i>
                        <i v-else class="iconfont icon-a-saoma13x"></i>
                        <input type="text" ref="input2" class="key-focus" data-model='idCode' v-model="idCode" @keyup.enter="couponVerify(idCode,1)" />
                    </div>
                    <button class="btn" @click="couponVerify(idCode,1)">核销</button>
                </div>
            </div>
        </div>
        <div class="right-box" v-show="navIndex==0">
            <div class="title">券列表</div>
            <div class="coupon-box">
                <div class="coupon-scroll"  v-scroll-anime="{up:'pay-up',down:'pay-down',liClass:'.item-tr',marginH:8}">
                    <div class="item-tr" v-for="item in couponsList" :key="item" >
                        <div class="coupons-box">
                            <div class="coupons-name">
                                <div class="name nowrap2">{{item.Coupon_Name}}</div>
                                <div class="describe nowrap"  v-show="item.Is_Have_Validity==true" >
                                    {{new Date(item.Begin_Date).Format("yyyy-MM-dd")}}至{{new Date(item.End_Date).Format("yyyy-MM-dd")}}止
                                </div>
                            </div>
                            <div class="bnt" @click="couponVerify(item)">核销</div>
                        </div> 
                    </div> 
                </div>
                <div class="item-operation">
                    <div class="float-right">
                        <div class="bnt-fangxiang" ref="pay-up"><i class="iconfont icon-fangxiang-up"></i></div>
                        <div class="bnt-fangxiang" ref="pay-down"><i class="iconfont icon-fangxiang-down"></i></div>
                    </div>
                </div>
            </div>
            <div class="footer-box"> 
                <button class="btn selected" @click="recordShow=true">查看核销记录</button>
            </div>
        </div>
        <!-- 券列表 -->
        <modal-load :isShow="ticketShow">
            <ticket-model :isShow="ticketShow" @closeModel="ticketShow=false" :Coupons="memberInfo?.Coupons"></ticket-model>
        </modal-load> 
        <!-- 选择卡信息 -->
        <modal-load :isShow="cardMemberShow">
            <select-card-member-info :isShow="cardMemberShow" @closeModel="cardMemberShow=false" :data="cardMemberList" @confirm="selectCardInfo"></select-card-member-info>
        </modal-load>
        <!-- 核销记录 -->
        <modal-load :isShow="recordShow">
            <recharge-record-model :isShow="recordShow" @closeModel="recordShow=false" :crmOpenCard="13" :Member_Type="4"></recharge-record-model>
        </modal-load> 
    </div>
</template>

<script>
import { ticketModel,selectCardMemberInfo,rechargeRecordModel } from '../model'
/**手动核销券 */
export default {
    name:'willCheckCoupon',
    components:{
        ticketModel,
        selectCardMemberInfo,
        rechargeRecordModel
    },
    data(){
        return {
            navIndex:0,
            /**卡号 */
            cardNo:'',
            /**卡id */
            card_AutoID:'',
             /**会员信息 */
            memberInfo:undefined,
            /**券列表 */
            ticketShow:false,
            /**选择卡信息 */
            cardMemberShow:false,
            /**多个卡信息 */
            cardMemberList:[],
            //核销输入框
            verifyInput:[],
            /** */
            idCode:"",
            //核销历史记录
            recordShow:false
        }
    },
    computed:{
        /**券数据 */
        couponsList(){
            return this.memberInfo?.Coupons?.filter(it=>it.Use_Status==0);
        }
    },
    watch:{
        cardNo(){
            this.memberInfo=null;
        },
        navIndex(newVal){
            if(newVal==1){
                this.$nextTick(()=>{
                    this.$refs.input2?.focus();
                })
            }else{
                this.$nextTick(()=>{
                    this.$refs.input?.focus();
                })
            }
        }
    },
    methods:{
        /**退出 */
        back(){
            this.$emit("close");
        },
        /*刷新当前页面 */
        reload() {
            this.$emit("reload");
        },
        ticketClick(){
            if(this.memberInfo){
                this.ticketShow = true;
            }
        },
        /**点击查询图标读卡   m1卡 Card_AutoID 卡id,Card_SN 内卡号 */
        selectReadCard(Card_AutoID,Card_SN){
            if(!this.cardNo && !Card_SN){
                this.$message.warning('请填写会员卡号')
                return
            }
            const loading = this.$loading({
                text: "读取会员信息中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.GetMemberInfo",{
                User_ID:this.userInfo?.User_ID,
                Member_Type:4,//4：微生活会
                DynamicNo:this.cardNo,
                Card_AutoID:Card_AutoID,
                Card_SN:Card_SN
            }).then((data)=>{
                loading.close();
                console.log('会员信息:',data)
                if(data.ResponseHeader.ResultCode==0){
                    if(data.ResponseBody.length>1){
                        this.cardMemberList=data.ResponseBody;
                        this.cardMemberShow=true;
                    }else{
                        this.selectCardInfo(data.ResponseBody[0])
                    }
                }else{
                    this.memberInfo=null,
                    this.$message.error("会员信息读取失败："+data.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.memberInfo=null,
                this.$message.error('会员信息读取失败：'+e);
                console.log('会员信息读取失败：'+e);
            })
        },
        /**点击 读卡 */
        readCard(){
            this.$webBrowser.redCardM1().then((d)=>{
                if(d){
                    if(d.state==0){
                        this.card_AutoID=d.data.cardID;
                        this.cardNo=d.data.cardNo;
                        this.selectReadCard(d.data.cardID,d.data.snr);
                    }else{
                        this.$message.error('卡信息读取失败：'+d.message);
                    }
                }
            })
        },
        /**多个卡信息时选择一个 */
        selectCardInfo(data){
            this.cardMemberShow=false;
            this.cardNo=data.Card_No;
            this.$nextTick(()=>{
                this.memberInfo = data;
                this.card_AutoID = this.memberInfo?.Bestech_Card_AutoID;
            })
        },
        /**券核销
         * @param {*} item 券码 或 券数据
         * @param {*} Verify_Type  核销类型 0：手动核销 1：扫码核销
         */
        couponVerify(item,Verify_Type=0){
            let userInfo=this.$auth.getUserInfo();
            let param={
                Pos_Czy:userInfo?.Login_Name,//操作员
                Member_Type:4,//4：微生活会员
            }
            if(Verify_Type==1){
                Object.assign(param,{
                    Verify_Type:1,//核销类型 0：手动核销 1：扫码核销
                    Coupon_Code:item//券码, 微生活核销使用
                })
            }else{
                Object.assign(param,{
                    Card_AutoID:this.memberInfo.Bestech_Card_AutoID, //卡主键
                    Card_No:this.memberInfo.Card_No,//卡号
                    Member_Name:this.memberInfo.MemberName,//会员姓名
                    Bestech_Card_KindName:this.memberInfo.Bestech_Card_KindName,//会员卡类名称
                    Mobile:this.memberInfo.Mobile, //手机号
                    Verify_Type:0,//核销类型 0：手动核销 1：扫码核销
                    Coupon_Code:item.Coupon_Code//券码, 微生活核销使用
                })
            }
            console.log(param)
            const loading = this.$loading({
                text: "卡券核销中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.MemberCouponBatchVerify",param).then((data)=>{
                loading.close();
                console.log('卡券核销返回信息:',data)
                if(data.ResponseHeader.ResultCode==0){
                    item.Use_Status=1;
                    this.$message.success("卡券核销完成");
                    if(data.ResponseBody){//打印数据
                        this.$webBrowser.posPrint(data.ResponseBody);
                    }
                    //this.reload();
                }else{
                    this.$message.error(data.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('卡券核销失败：'+e.message);
                console.log('卡券核销：',e);
            })
        }
    }
}
</script>

<style lang="scss">
@import "./willCheckCoupon.scss";
</style>